import * as React from 'react';
import { ICardSubcardsAddProps } from './types';
import { SelectListItem, Tooltip } from 'kui';
import { LIST_LABEL } from 'app/const';
import { escape } from 'underscore';

export function CardSubcardsAdd({
    img,
    text,
    textSub,
    value,
    className
}: ICardSubcardsAddProps) {

    return (
        <SelectListItem
            key={value}
            icon={img}
            list={textSub}
            listLabel={LIST_LABEL + escape(textSub)}
            value={value}
            className={className}
        >
            <Tooltip
                isNoWrap={true}
                value={escape(text)}
            >
                <span>{text}</span>
            </Tooltip>
        </SelectListItem>
    );
};
